import { toast } from "react-toastify"

const initialState = {
    achiev: null,
    error: null
}

export default (state = initialState, { type, payload }) => {
    switch (type) {
        case 'ACHIEVEMENT_GOT_SUCCESS':
            toast.success(`Parabéns! Conquistou a proeza ${payload.rarity.toLowerCase()} - ${payload.name}`)
            return { ...state }
        case 'NO_ACHIEVEMENT_GOT':
            return { ...state }
        case 'ADD_ACHIEVEMENTS_SUCCESS':
            toast.success(`Proeza(s) encontrada(s) foram adicionadas com sucesso à sua lista de proezas conquistadas!`)
            return { ...state }
        case 'ADD_ACHIEVEMENTS_ERROR':
            toast.error('Ocorreu um erro a adicionar a proeza(s) que encontrou recentemente! Tente novamente mais tarde ao terminar uma partida do Mundo em Notícias, ao jogar uma narrativa ou ao comentar.')
            return { ...state }

        default:
            return state
    }
}
